<template>
  <BDLayout>
    <div class="transaction">
      <section id="bd-loss-records">
        <div class="container">
          <h6 class="fw-bold mb-3">Loss Records</h6>

          <!-- Add Loss Record form (commented out — records are created automatically when an opportunity is marked LOST)
          <div class="card mb-4 p-3">
            <p class="fw-semibold mb-2">Add Loss Record</p>
            <form @submit.prevent="createRecord" class="row g-2 align-items-end">
              <div class="col-md-3">
                <label class="form-label">Submission ID</label>
                <input v-model="form.submissionId" class="form-control" placeholder="Submission ID" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Loss Reason</label>
                <input v-model="form.lossReason" class="form-control" placeholder="Reason" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Competitor</label>
                <input v-model="form.competitor" class="form-control" placeholder="Competitor (optional)" />
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button class="btn btn-primary w-100" :disabled="saving">
                  <span v-if="saving" class="spinner-border spinner-border-sm me-1"></span>
                  Add
                </button>
              </div>
            </form>
          </div>
          -->

          <!-- Table -->
          <div class="card p-3">
            <div v-if="loading" class="text-muted py-3 text-center">
              <span class="spinner-border spinner-border-sm me-2"></span>Loading…
            </div>
            <table v-else class="table table-hover table-sm mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Submission</th>
                  <th>Reason</th>
                  <th>Competitor</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in records" :key="r.id">
                  <td>{{ r.id }}</td>
                  <td>{{ r.submissionId }}</td>
                  <td>{{ r.lossReason }}</td>
                  <td>{{ r.competitor || '—' }}</td>
                  <td>
                    <button class="btn btn-sm btn-outline-danger" @click="remove(r.id)">Delete</button>
                  </td>
                </tr>
                <tr v-if="records.length === 0">
                  <td colspan="5" class="text-muted text-center py-3">No loss records found.</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>
    </div>
  </BDLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import { bidApi } from '@/api/bid'
import BDLayout from '@/components/BDLayout.vue'

export default {
  name: 'LossRecords',
  components: { BDLayout },
  setup() {
    const records = ref([])
    const loading = ref(false)
    const saving = ref(false)
    const form = ref({ submissionId: '', lossReason: '', competitor: '' })

    const load = async () => {
      loading.value = true
      try {
        records.value = await bidApi.listLossRecords()
      } catch (err) {
        console.error('Failed to load loss records', err)
      } finally {
        loading.value = false
      }
    }

    const createRecord = async () => {
      if (!form.value.submissionId || !form.value.lossReason) return
      saving.value = true
      try {
        const payload = {
          submissionId: form.value.submissionId,
          lossReason: form.value.lossReason,
          competitor: form.value.competitor,
        }
        const res = await bidApi.createLossRecord(payload)
        const created = res && (res.data || res.item) ? (res.data || res.item) : res
        records.value.unshift(created)
        form.value.submissionId = ''
        form.value.lossReason = ''
        form.value.competitor = ''
      } catch (err) {
        console.error('Failed to create loss record', err)
      } finally {
        saving.value = false
      }
    }

    const remove = async (id) => {
      try {
        await bidApi.deleteLossRecord(id)
        records.value = records.value.filter(r => r.id !== id)
      } catch (err) {
        console.error('Failed to delete loss record', err)
      }
    }

    onMounted(load)

    return { records, loading, form, createRecord, remove, saving }
  },
}
</script>

<style scoped>
.card { background: #fff; border-radius: 8px; border: 1px solid #e5e7eb; }
</style>
